import styled from "@emotion/styled";

export const FlexS = styled.div` 
  display        : flex;
  flex-flow      : ${props => props.theme.direction.xs};
  justify-content: ${props => props.theme.jc.xs};
  align-items    : ${props => props.theme.alg.xs};
  flex           : ${props => props.theme.elastic.xs};
  
  @media all and (min-width:480px){
      flex-flow      : ${props => props.theme.direction["sm"]};
      justify-content: ${props => props.theme.jc["sm"]};
      align-items    : ${props => props.theme.alg["sm"]};
      flex           : ${props => props.theme.elastic["sm"]} ;
    
  }
  
  @media all and (min-width:768px){
      flex-flow      : ${props => props.theme.direction["md"]};
      justify-content: ${props => props.theme.jc["md"] };
      align-items    : ${props => props.theme.alg["md"] };
      flex           : ${props => props.theme.elastic["md"]};
    
  }
  
  @media all and (min-width:1024px){
      flex-flow      : ${props => props.theme.direction["lg"]};
      justify-content: ${props => props.theme.jc["lg"]};
      align-items    : ${props => props.theme.alg["lg"]};
      flex           : ${props => props.theme.elastic["lg"]};
    
  }
  
  @media all and (min-width:1280px){
      flex-flow      : ${props => props.theme.direction["xl"]};
      justify-content: ${props => props.theme.jc["xl"]};
      align-items    : ${props => props.theme.alg["xl"]};
      flex           : ${props => props.theme.elastic["xl"]};
  }
`;

export const Elastic = styled.div`
  flex: ${(props) => (props.flex ? props.flex : "0 0 auto")};
`;

